(function () {
  'use strict';

  if (customElements.get('spider-media-lightbox')) return;

  customElements.define('spider-media-lightbox', class extends HTMLElement {
    constructor() {
      super();
      this.lightbox = null;
      this.slides = [];
      this.currentIndex = 0;
      this.totalSlides = 0;
      this.counterCurrent = null;
      this.boundOnKeydown = this.onKeydown.bind(this);
      this.touchStartX = 0;
      this.touchEndX = 0;
    }

    connectedCallback() {
      this.lightbox = this.querySelector('.spider-media__lightbox');
      if (!this.lightbox) return;

      this.slides = this.querySelectorAll('.spider-media__lightbox-slide');
      this.totalSlides = this.slides.length;
      this.counterCurrent = this.querySelector('.spider-media__lightbox-current');

      // Thumbnail click handlers
      var self = this;
      this.querySelectorAll('.spider-media__thumb').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var index = parseInt(thumb.getAttribute('data-index'), 10);
          self.open(index);
        });
      });

      // Close button
      var closeBtn = this.querySelector('.spider-media__lightbox-close');
      if (closeBtn) {
        closeBtn.addEventListener('click', function () {
          self.close();
        });
      }

      // Backdrop click to close
      var backdrop = this.querySelector('.spider-media__lightbox-backdrop');
      if (backdrop) {
        backdrop.addEventListener('click', function () {
          self.close();
        });
      }

      // Navigation arrows
      var prevBtn = this.querySelector('.spider-media__lightbox-nav--prev');
      var nextBtn = this.querySelector('.spider-media__lightbox-nav--next');
      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          self.prev();
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          self.next();
        });
      }

      // Touch swipe support on lightbox content
      var content = this.querySelector('.spider-media__lightbox-content');
      if (content) {
        content.addEventListener('touchstart', function (e) {
          self.touchStartX = e.changedTouches[0].screenX;
        }, { passive: true });
        content.addEventListener('touchend', function (e) {
          self.touchEndX = e.changedTouches[0].screenX;
          self.handleSwipe();
        }, { passive: true });
      }
    }

    open(index) {
      this.currentIndex = index;
      this.showSlide(index);
      this.lightbox.setAttribute('data-open', 'true');
      document.body.classList.add('spider-media-lightbox-open');
      document.addEventListener('keydown', this.boundOnKeydown);
    }

    close() {
      this.lightbox.setAttribute('data-open', 'false');
      document.body.classList.remove('spider-media-lightbox-open');
      document.removeEventListener('keydown', this.boundOnKeydown);
      this.pauseAllVideos();
    }

    prev() {
      var newIndex = this.currentIndex - 1;
      if (newIndex < 0) newIndex = this.totalSlides - 1;
      this.currentIndex = newIndex;
      this.showSlide(newIndex);
    }

    next() {
      var newIndex = this.currentIndex + 1;
      if (newIndex >= this.totalSlides) newIndex = 0;
      this.currentIndex = newIndex;
      this.showSlide(newIndex);
    }

    showSlide(index) {
      this.pauseAllVideos();
      this.slides.forEach(function (slide) {
        slide.classList.remove('is-active');
      });
      var activeSlide = this.slides[index];
      if (activeSlide) {
        activeSlide.classList.add('is-active');
        if (activeSlide.getAttribute('data-type') === 'video') {
          var video = activeSlide.querySelector('video');
          if (video) {
            video.play().catch(function () {});
          }
        }
      }
      if (this.counterCurrent) {
        this.counterCurrent.textContent = index + 1;
      }
    }

    pauseAllVideos() {
      this.querySelectorAll('.spider-media__lightbox-slide video').forEach(function (video) {
        video.pause();
      });
    }

    onKeydown(e) {
      if (e.key === 'Escape') this.close();
      if (e.key === 'ArrowLeft') this.prev();
      if (e.key === 'ArrowRight') this.next();
    }

    handleSwipe() {
      var diffX = this.touchStartX - this.touchEndX;
      var threshold = 50;
      if (Math.abs(diffX) > threshold) {
        if (diffX > 0) {
          this.next();
        } else {
          this.prev();
        }
      }
    }
  });
})();
